export default __webpack_public_path__ + "static/media/login-seperator.525cf6be.png";